export type { VisitPortalState } from './reducer';
export { visitPortalReducer } from './reducer';
